import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import { CookiesProvider } from "react-cookie";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <CookiesProvider>
            <KindeProvider
                clientId={process.env.REACT_APP_KINDE_CLIENT_ID}
                domain={process.env.REACT_APP_KINDE_DOMAIN}
                redirectUri={process.env.REACT_APP_KINDE_REDIRECT_URI}
                logoutUri={process.env.REACT_APP_KINDE_LOGOUT_URI}
            >
                <App />
            </KindeProvider>
        </CookiesProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
